import { fabric } from 'fabric'

const TextMode = {
  AUTOFIT: 'autofit',
  TRUNCATE: 'truncate'
} as const

const MIN_FONT_SIZE_FOR_AUTO_FIT = 5

const fromObject = fabric.Textbox.fromObject
const _splitTextIntoLines = fabric.Textbox.prototype._splitTextIntoLines
const initDimensions = fabric.Textbox.prototype.initDimensions

fabric.Textbox.prototype.maxLines = 0
fabric.Textbox.prototype.textMode = TextMode.AUTOFIT

fabric.Textbox.fromObject = function(object: fabric.Textbox, callback) {
  if (object?.maxLines && object.maxLines > 0 && typeof object.textMode === 'undefined') {
    object.textMode = TextMode.TRUNCATE
  }
  return fromObject(object, callback)
}

fabric.Textbox.prototype.toObject = (function(toObject) {
  return function(this: fabric.Textbox) {
    const maxLines = this.maxLines
    const textMode = this.textMode

    return fabric.util.object.extend(toObject.call(this), {
      maxLines,
      textMode
    })
  }
})(fabric.Textbox.prototype.toObject)

export function enableTextboxTruncation() {
  fabric.Textbox.prototype._splitTextIntoLines = function(text: string) {
    if (!(this.textMode === TextMode.TRUNCATE || typeof this.textMode === 'undefined')) {
      return _splitTextIntoLines.call(this, text)
    }

    var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text),
      graphemeLines = this._wrapText(newText.lines, this.width!),
      lines = new Array(graphemeLines.length)
    for (var i = 0; i < graphemeLines.length; i++) {
      lines[i] = graphemeLines[i].join('')
    }

    if (!this.isEditing && this.maxLines) {
      if (lines.length > this.maxLines) {
        lines = lines.splice(0, this.maxLines)
        const lastLineIndex = lines.length - 1
        lines[lastLineIndex] = lines[lastLineIndex].slice(0, -1) + '…'
      }

      if (graphemeLines.length > this.maxLines) {
        graphemeLines = graphemeLines.splice(0, this.maxLines)
        const lastLineIndex = graphemeLines.length - 1
        graphemeLines[lastLineIndex].splice(-1, 1, '…')
      }
    }

    newText.lines = lines
    newText.graphemeLines = graphemeLines
    return newText
  }
}

export function disableTextboxTruncation() {
  fabric.Textbox.prototype._splitTextIntoLines = _splitTextIntoLines
}

export function enableTextboxAutoFit() {
  fabric.Textbox.prototype.initDimensions = function(this: fabric.Textbox) {
    if (this.textMode !== TextMode.AUTOFIT) {
      initDimensions.call(this)
      return
    }

    const oldWidth = this.width!
    const oldHeight = this.height!

    this._clearCache()
    this._splitText()

    const newWidth = this.calcTextWidth()
    const newHeight = this.calcTextHeight()

    if (
      (newWidth > oldWidth || newHeight > oldHeight) &&
      this.fontSize! > MIN_FONT_SIZE_FOR_AUTO_FIT
    ) {
      this.fontSize! -= 1
      this.initDimensions()
      return
    }

    initDimensions.call(this)
  }
}

export function disableTextboxAutoFit() {
  fabric.Textbox.prototype.initDimensions = initDimensions
}
